export function pad(num: number, size: number) {
  let newNum = num.toString();
  while (newNum.length < size) newNum = "0" + newNum;
  return newNum;
}

export function formatCompactNumber(
  value: number,
  locale: string | undefined,
  maximumFractionDigits: number = 1
) {
  if (!Number.isFinite(value)) return String(value);
  const absValue = Math.abs(value);
  let divisor = 1;
  let suffix = "";

  if (absValue >= 1_000_000_000_000) {
    divisor = 1_000_000_000_000;
    suffix = "T";
  } else if (absValue >= 1_000_000_000) {
    divisor = 1_000_000_000;
    suffix = "B";
  } else if (absValue >= 1_000_000) {
    divisor = 1_000_000;
    suffix = "M";
  } else if (absValue >= 1_000) {
    divisor = 1_000;
    suffix = "K";
  }

  const formatter = new Intl.NumberFormat(locale, {
    maximumFractionDigits,
    minimumFractionDigits: 0,
  });

  const formatted = formatter.format(divisor === 1 ? value : value / divisor);
  return `${formatted}${suffix}`;
}
